import { get } from 'lodash'

export const getBTPaymentMethods = state => get(state, 'braintree.paymentMethods')
